import { Reducer, Action } from "redux";

import { CommonActionTypes } from "./common.types";

import { Common } from "../../models";

const INITIAL_STATE: Common = {
  activeTab: 0,
  loading: false,
  succcess: "",
  error: "",
  branches: [],
  hubs: [],
  varieties: [],
  crops: [],
  cropsUnit: [],
  bagTypeList: [],
  selectedCrop: null,
  selectedDeliveryStatus: null,
  selectedPoStatus: null,
  selectedPayment: null,
  selectedSaudaType: null,
  selectedAuctionType: null,
  selectedBranch: null,
  initialDataLoaded: false,
  supplierBidsData: [],
  activeBidsData: [],
  parameters: [],
  season: [],
  privacyPolicy: "",
  tc: ``,
};

const commonReducer: Reducer<Common, Action> = (
  state = INITIAL_STATE,
  action: any
) => {
  switch (action.type) {
    case CommonActionTypes.SET_BRANCHES:
      return {
        ...state,
        branches: action.payload,
      };

    case CommonActionTypes.SET_ACTIVE_TAB:
      return {
        ...state,
        activeTab: action.payload,
      };
    case CommonActionTypes.SET_HUBS:
      return {
        ...state,
        hubs: action.payload,
      };
    case CommonActionTypes.SET_VARIETIES:
      return {
        ...state,
        varieties: action.payload,
      };
    case CommonActionTypes.SET_BAG_TYPE_LIST:
      return {
        ...state,
        bagTypeList: action.payload,
      };
    case CommonActionTypes.SET_CROPS:
      return {
        ...state,
        crops: action.payload,
      };
    case CommonActionTypes.SET_PARAMETERS:
      return {
        ...state,
        parameters: action.payload,
      };
    case CommonActionTypes.SET_SEASON:
      return {
        ...state,
        season: action.payload,
      };
    case CommonActionTypes.SET_AUCTION_TYPE:
      return {
        ...state,
        selectedAuctionType: action.payload,
      };
    case CommonActionTypes.SET_CROPS_UNIT:
      return {
        ...state,
        cropsUnit: action.payload,
      };
    case CommonActionTypes.SET_SELECTED_CROP:
      return {
        ...state,
        selectedCrop: action.payload,
      };
    case CommonActionTypes.SET_SELECTED_DELIVERY:
      return {
        ...state,
        selectedDeliveryStatus: action.payload,
      };
    case CommonActionTypes.SET_SELECTED_PO:
      return {
        ...state,
        selectedPoStatus: action.payload,
      };
    case CommonActionTypes.SET_SELECTED_PAYMENT:
      return {
        ...state,
        selectedPayment: action.payload,
      };
    case CommonActionTypes.SET_SELECTED_SAUDHA:
      return {
        ...state,
        selectedSaudaType: action.payload,
      };
    case CommonActionTypes.SET_SELECTED_BRANCH:
      return {
        ...state,
        selectedBranch: action.payload,
      };
    case CommonActionTypes.SET_INITIAL_DATA_LOADED:
      return {
        ...state,
        initialDataLoaded: action.payload,
      };
    case CommonActionTypes.SET_TC:
      return {
        ...state,
        tc: action.payload,
      };
    case CommonActionTypes.SET_PRIVACY:
      return {
        ...state,
        privacyPolicy: action.payload,
      };
    case CommonActionTypes.SET_PARAMETERS:
      return {
        ...state,
        parameters: action.payload,
      };
    case CommonActionTypes.SET_SUPPLIER_BIDS:
      return {
        ...state,
        supplierBidsData: action.payload,
      };
    case CommonActionTypes.SET_LOADING:
      return {
        ...state,
        loading: action.payload,
      };
    case CommonActionTypes.SET_SUCCESS:
      return {
        ...state,
        succcess: action.payload,
      };
    case CommonActionTypes.SET_ERROR:
      return {
        ...state,
        error: action.payload,
      };
    case CommonActionTypes.SET_AUCTION_BID:
      return {
        ...state,
        activeBidsData: action.payload,
      };
    case CommonActionTypes.RESET_REDUCER:
      return INITIAL_STATE;
    default:
      return state;
  }
};

export default commonReducer;
